import React, { useState, useEffect } from 'react';
import Sidebar from '../Shared/Sidebar';
import Icon from '../Shared/Icons';
import {
  PROGRAMS, EDITABLE_FIELDS, DEFAULT_NAMES, applyProgramOverrides,
} from '../../config/programs';
import {
  fetchProgramOverrides, saveProgramOverride, resetProgramOverride,
} from '../../utils/programData';
import { S, T } from './ui';

// ── MAJINA YA PROGRAMU ──────────────────────────────────────────────────
// Jina, maelezo na rangi ni ya taasisi — mnaweza kuyabadilisha wakati
// wowote. Muundo wa ndani (bloku za ripoti, aina za wanachama) haubadiliki,
// hivyo data yote iliyokwisha kusanywa inabaki salama.

export default function ProgramSettings() {
  const [forms, setForms] = useState({});
  const [saving, setSaving] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [, force] = useState(0);

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const overrides = await fetchProgramOverrides();
      applyProgramOverrides(overrides);
      const f = {};
      PROGRAMS.forEach(p => {
        f[p.id] = {
          name: p.name, short: p.short, tagline: p.tagline,
          color: p.color, accent: p.accent,
        };
      });
      setForms(f);
      force(x => x + 1);
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia majina.'); }
  }

  function ch(pid, k, v) {
    setForms(f => ({ ...f, [pid]: { ...f[pid], [k]: v } }));
  }

  async function save(pid) {
    const f = forms[pid];
    if (!f?.name?.trim()) { setErr('Jina haliwezi kuwa tupu.'); return; }
    setSaving(pid); setErr('');
    try {
      const payload = {};
      EDITABLE_FIELDS.forEach(k => { payload[k] = f[k] || ''; });
      await saveProgramOverride(pid, payload);
      applyProgramOverrides([{ id: pid, ...payload }]);
      setMsg('Jina limebadilishwa. Litaonekana kila mahali kwenye App.');
      force(x => x + 1);
      setTimeout(() => setMsg(''), 3500);
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi.'); }
    setSaving('');
  }

  async function reset(pid) {
    if (!window.confirm('Rudisha jina la awali?')) return;
    setSaving(pid);
    try {
      await resetProgramOverride(pid);
      const d = DEFAULT_NAMES[pid];
      applyProgramOverrides([{ id: pid, ...d }]);
      setForms(f => ({ ...f, [pid]: { ...d } }));
      setMsg('Jina la awali limerudishwa.');
      force(x => x + 1);
      setTimeout(() => setMsg(''), 3000);
    } catch (e) { console.error(e); setErr('Imeshindikana.'); }
    setSaving('');
  }

  return (
    <div style={S.layout}>
      <Sidebar />
      <div style={S.main}>

        <h1 style={S.h1}>Majina ya Programu</h1>
        <p style={{ ...S.sub, marginTop: '6px', marginBottom: '18px' }}>
          Weka majina ya miradi yenu wenyewe. Jina jipya linaonekana kila mahali —
          kwenye dashboard, ripoti, na uchambuzi wa AI.
        </p>

        {msg && <div style={S.ok}>{msg}</div>}
        {err && <div style={S.err}>{err}</div>}

        <div style={{ ...S.card, background: '#FAF8F3', fontSize: '12px', color: T.muted, lineHeight: 1.8 }}>
          <Icon name="info" size={13} color={T.orange} />{' '}
          <strong style={{ color: T.ink }}>Kinachobadilika ni jina tu.</strong> Muundo wa ndani —
          maswali ya ripoti, aina za wanachama, na kitambulisho cha programu — haubadiliki.
          Ndio maana data yote mliyokwisha kukusanya inabaki salama hata mkibadilisha
          jina mara nyingi.
        </div>

        {PROGRAMS.map(p => {
          const f = forms[p.id] || {};
          const changed = JSON.stringify(f) !== JSON.stringify({
            name: p.name, short: p.short, tagline: p.tagline, color: p.color, accent: p.accent,
          });
          const isDefault = JSON.stringify(f) === JSON.stringify(DEFAULT_NAMES[p.id]);

          return (
            <div key={p.id} style={{ ...S.card, borderLeft: `4px solid ${f.color || p.color}` }}>

              {/* Onyesho la moja kwa moja */}
              <div style={{
                background: `linear-gradient(135deg, ${f.color || p.color}, ${f.accent || p.accent})`,
                borderRadius: '14px', padding: '16px', color: '#fff', marginBottom: '18px',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Icon name={p.icon} size={20} color="#fff" />
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontFamily: T.serif, fontSize: '17px', lineHeight: 1.2 }}>
                      {f.name || p.name}
                    </div>
                    <div style={{ fontSize: '11.5px', opacity: 0.85, marginTop: '3px' }}>
                      {f.tagline || p.tagline}
                    </div>
                  </div>
                </div>
              </div>

              <label style={S.label}>Jina kamili</label>
              <input style={{ ...S.input, marginBottom: '14px' }} value={f.name || ''}
                onChange={e => ch(p.id, 'name', e.target.value)} />

              <label style={S.label}>Jina fupi (linalotumika kwenye jedwali na kadi)</label>
              <input style={{ ...S.input, marginBottom: '14px' }} value={f.short || ''}
                onChange={e => ch(p.id, 'short', e.target.value)} />

              <label style={S.label}>Maelezo mafupi</label>
              <input style={{ ...S.input, marginBottom: '14px' }} value={f.tagline || ''}
                onChange={e => ch(p.id, 'tagline', e.target.value)} />

              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 130px' }}>
                  <label style={S.label}>Rangi kuu</label>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '14px' }}>
                    <input type="color" value={f.color || p.color}
                      onChange={e => ch(p.id, 'color', e.target.value)}
                      style={{ width: '44px', height: '40px', border: 'none', background: 'none', cursor: 'pointer', padding: 0 }} />
                    <input style={{ ...S.input, flex: 1 }} value={f.color || ''}
                      onChange={e => ch(p.id, 'color', e.target.value)} />
                  </div>
                </div>
                <div style={{ flex: '1 1 130px' }}>
                  <label style={S.label}>Rangi ya pili</label>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '14px' }}>
                    <input type="color" value={f.accent || p.accent}
                      onChange={e => ch(p.id, 'accent', e.target.value)}
                      style={{ width: '44px', height: '40px', border: 'none', background: 'none', cursor: 'pointer', padding: 0 }} />
                    <input style={{ ...S.input, flex: 1 }} value={f.accent || ''}
                      onChange={e => ch(p.id, 'accent', e.target.value)} />
                  </div>
                </div>
              </div>

              <div style={{ fontSize: '11px', color: T.muted, marginBottom: '16px' }}>
                Kitambulisho cha programu: <code>{p.id}</code> — hakibadiliki kamwe.
              </div>

              <div style={{ display: 'flex', gap: '9px', flexWrap: 'wrap' }}>
                <button style={{ ...S.btn, background: f.color || p.color, opacity: saving === p.id || !changed ? 0.5 : 1 }}
                  disabled={saving === p.id || !changed} onClick={() => save(p.id)}>
                  {saving === p.id ? 'Inahifadhi…' : 'Hifadhi'}
                </button>
                {!isDefault && (
                  <button style={S.btnGhost} onClick={() => reset(p.id)}>Rudisha la awali</button>
                )}
              </div>
            </div>
          );
        })}

      </div>
    </div>
  );
}
